import { FieldDocumentsDependencies } from '../../components/CompanyProfileModulesWrapper/types';

export const fieldDocumentsDependencies: FieldDocumentsDependencies = {
  fullName: [
    {
      requiredDocuments: ['egrul'],
      checkFn: (changedKeys) => changedKeys.includes('fullName'),
    },
  ],
  shortName: [],
  kpp: [
    {
      requiredDocuments: ['egrul', 'registration'],
      checkFn: (changedKeys) => changedKeys.includes('kpp'),
    },
  ],
  legalAddress: [
    {
      requiredDocuments: ['egrul'],
      checkFn: (changedKeys) => changedKeys.includes('legalAddress'),
    },
  ],
  postalAddress: [],
  settlementsCurrency: [],
  representativeFullName: [
    {
      requiredDocuments: ['egrul', 'decision'],
      checkFn: (changedKeys, values) =>
        changedKeys.includes('representativeFullName') &&
        ['director', 'general_director', 'management_company'].some((job) =>
          values.jobTitle.includes(job)
        ),
    },
    {
      requiredDocuments: ['decision'],
      checkFn: (changedKeys, values) =>
        changedKeys.includes('representativeFullName') &&
        !['director', 'general_director', 'management_company'].some((job) =>
          values.jobTitle.includes(job)
        ),
    },
  ],
  jobTitle: [
    {
      requiredDocuments: ['egrul', 'decision'],
      checkFn: (changedKeys, values) =>
        !changedKeys.includes('representativeFullName') &&
        changedKeys.includes('jobTitle') &&
        ['director', 'general_director', 'management_company'].some((job) =>
          values.jobTitle.includes(job)
        ),
    },
    {
      requiredDocuments: ['decision'],
      checkFn: (changedKeys, values) =>
        changedKeys.includes('jobTitle') &&
        !['director', 'general_director', 'management_company'].some((job) =>
          values.jobTitle.includes(job)
        ),
    },
  ],
  actionReason: [
    {
      requiredDocuments: ['egrul', 'decision'],
      checkFn: (changedKeys, values) =>
        !changedKeys.includes('representativeFullName') &&
        ['director', 'general_director', 'management_company'].some((job) =>
          values.jobTitle.includes(job)
        ) &&
        changedKeys.includes('actionReason'),
    },
    {
      requiredDocuments: ['decision'],
      checkFn: (changedKeys, values) =>
        changedKeys.includes('actionReason') &&
        !['director', 'general_director', 'management_company'].some((job) =>
          values.jobTitle.includes(job)
        ),
    },
  ],
  availabilityEdo: [],
  operatorEdo: [],

  registration: [],
  egrul: [],
  company_card: [],
  charter: [],
  decision: [],
};
